import TextField from "@material-ui/core/TextField";
import React, { useEffect, useState } from "react";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import * as globalFuncs from "../../globalFuncs/Entities/Product/Index";
import domtoimage from "dom-to-image";
import Button from "@material-ui/core/Button";
import { jsPDF } from "jspdf";
import { isMobile } from "react-device-detect";
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import { Link } from "react-router-dom";

const StyledTableCell = withStyles((theme) => ({
    root: {
        [theme.breakpoints.down("sm")]: {
            padding: "17px",
        },
        [theme.breakpoints.down("xs")]: {
            padding: "16px 14px",
        },
    },
    head: {
        backgroundColor: "#A22020",
        color: theme.palette.common.white,
        [theme.breakpoints.down("xs")]: {
            fontSize: 13,
            borderLeft: "1px solid rgba(255, 255, 255, 0.29)",
            textAlign: 'center'
        },
    },
    body: {
        fontSize: 14,
        [theme.breakpoints.down("xs")]: {
            fontSize: 12,
        },
    },
    tbody: {
        th: {
            borderLeft: "1px solid #000",
        },
    },
}))(TableCell);



const StyledTableRow = withStyles((theme) => ({
    root: {
        backgroundColor: "#f2f2f2",
    },
}))(TableRow);
const TextArea = withStyles((theme) => ({
    root: {
        backgroundColor: "transparent",
    },
    textArea: {
        backgroundColor: "transparent",
        padding: '15px',
    },
}))(TextField);

function createData(row, name, weight, priceCount, count, price) {
    return { row, name, weight, count, priceCount, price };
}
var options = {
    quality: 0.99,
    width: 1700,
    height: 1700,
};

let rows = [];

const useStyles = makeStyles((theme) => ({
    btnWhite: {
        backgroundColor: "#fff",
        fontWeight: "400",
        boxShadow: "none",
        border: "0.5px solid #828282",
        borderRadius: "10px",
        "&:hover": {
            backgroundColor: "#fff",
        },
        color: "#101010",
    },
    print: {
        backgroundColor: "#fff",
        fontWeight: "700",
        boxShadow: "0px 1px 2px 2px rgba(0, 0, 0, 0.15)",
        borderRadius: "5px",
        "&:hover": {
            backgroundColor: "#fff",
        },
        color: "#101010",
    },
    btnBack: {
        backgroundColor: "#417557",
        fontWeight: "400",
        boxShadow: "none",
        borderRadius: "10px",
        width: "160px",
        "&:hover": {
            backgroundColor: "#417557",
        },
        color: "#fff",
    },
    table: {
        minWidth: 700,
    },
    box: {
        width: "980px",
        [theme.breakpoints.down("md")]: {
            width: "830px",
        },
        [theme.breakpoints.down("sm")]: {
            width: "90%",
        },
        [theme.breakpoints.down("xs")]: {
            width: "94%",
        },
    },
    fontSize: {
        fontSize: "16px",
        [theme.breakpoints.down("sm")]: {
            fontSize: "16px",
        },
        [theme.breakpoints.down("xs")]: {
            fontSize: "15px",
        },
    },
    md: {
        [theme.breakpoints.up("sm")]: {
            textAlign: "center",
        },
        [theme.breakpoints.down("md")]: {
            textAlign: "left",
        },
        [theme.breakpoints.down("sm")]: {
            textAlign: "center",
        },
    },
}));

const stockCheck = (inner) => {
    switch (inner) {
        case "OutOfStock":
            return "موجود نمی باشد";
        default:
            return inner;
    }
};

export default function FinalFactorGenerator(props) {
    const classes = useStyles();
    const [state, setState] = useState([]);
    const [showBtn, setShowBtn] = useState(true);
    let { factor } = props;
    const [width, setWidth] = useState(window.innerWidth)
    const handleResize = () => {
        setWidth(window.innerWidth)
    }
    useEffect(() => {
        if (typeof props.showBtn === "boolean") {
            setShowBtn(props.showBtn)
        }
        handleResize()
        window.addEventListener('resize', handleResize)
        return () => {
            window.removeEventListener('resize', handleResize);
        }
    }, [])
    useEffect(() => {
        let rows = [];
        factor.products.forEach((item, i) => {
            rows.push(
                createData(
                    i + 1,
                    item.title,
                    item.packId,
                    item.unitPrice,
                    stockCheck(item.packCount),
                    stockCheck(item.totalPrice)
                )
            );
        });
        setState(rows);
    }, [factor]);
    function printDocument() {
        const input = document.getElementById("printAble");
        const pdf = new jsPDF();
        if (isMobile) {
            if (pdf) {
                domtoimage.toPng(input, { quality: 0.99 }).then((imgData) => {
                    const pdf2 = new jsPDF("p", "mm", [400, 480]);
                    const imgProps = pdf2.getImageProperties(imgData);
                    const pdfWidth = imgProps.width;
                    const pdfHeight = imgProps.height;

                    pdf2.addImage(imgData, "PNG", 0, 0, 400, 480);
                    pdf2.save("factor.pdf");
                });
            }
        }
        else {
            domtoimage.toPng(input, options).then((imgData) => {
                pdf.addImage(imgData, "PNG", -125, 2, 325, 325);
                pdf.save("factor.pdf");
            });
        }
    }
    if (factor.length > 0) {
        return (
            <Box p={40} textAlign="center">
                اطلاعاتی یافت نشد
            </Box>
        );
    } else {
        return (
            <Box width="100%" height="100%" bgcolor="#fff">
                <Box className={classes.box} m="30px auto">
                    <div id="printAble">

                        <Box mt={1} textAlign="center">
                            جزئیات فاکتور شماره <b dir="ltr">{factor.invoiceNumber} </b>
                        </Box>
                        <Box mt={5} mb={4} p={3} pb={5} borderRadius={10} bgcolor="#f2f2f2">
                            <Grid container>
                                <Grid xl={4} lg={4} md={4} sm={6} xs={12} style={{ textAlign: isMobile && 'center' }}>
                                    <br />
                نام و نام خانوادگی :<b>{factor.fullName}</b>
                                </Grid>
                                <Grid xl={4} lg={4} md={4} sm={6} xs={12} style={{ textAlign: isMobile && 'center' }}>
                                    <div className={classes.md}>
                                        <br />
                  شماره تماس :<b>{factor.mobileNumber}</b>
                                    </div>
                                </Grid>
                                <Grid xl={4} lg={4} md={4} sm={6} xs={12} style={{ textAlign: isMobile && 'center' }}>
                                    <div className={classes.md}>
                                        <br />
                  شماره فاکتور: <b dir="ltr">{factor.invoiceNumber} </b>
                                    </div>
                                </Grid>
                                <Grid xl={5} lg={5} md={5} sm={6} xs={12} style={{ textAlign: isMobile && 'center' }}>
                                    <div>
                                        <br />
                  نحوه ارسال :<b>{factor.wayOfSend}</b>
                                    </div>
                                </Grid>
                                <Grid xl={7} lg={7} md={7} sm={12} xs={12} style={{ textAlign: isMobile && 'center' }}>
                                    <br />
                آدرس:<b>{factor.address}</b>
                                </Grid>
                            </Grid>
                        </Box>
                        <TableContainer component={Paper}>
                            <Table className={classes.table} aria-label="customized table">
                                <TableHead>
                                    <TableRow>
                                        <StyledTableCell>ردیف</StyledTableCell>
                                        <StyledTableCell>نام محصول</StyledTableCell>
                                        <StyledTableCell align="center">پک (گرم)</StyledTableCell>
                                        <StyledTableCell align="center">
                                            قیمت واحد &nbsp;{!isMobile ? ('(تومان)') : '(ت)'}
                                        </StyledTableCell>
                                        <StyledTableCell align="center">تعداد بسته</StyledTableCell>

                                        <StyledTableCell align="center">
                                            قیمت کل&nbsp;{!isMobile ? ('(تومان)') : '(ت)'}
                                        </StyledTableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {state.map((row) => (
                                        <StyledTableRow key={row.name}>
                                            <StyledTableCell
                                                style={{ borderBottom: "1px solid", borderColor: "#fff" }}
                                            >
                                                {row.row}
                                            </StyledTableCell>
                                            <StyledTableCell
                                                style={{ borderRight: "1px solid", borderColor: "#fff" }}
                                                align="left"
                                            >
                                                {row.name}
                                            </StyledTableCell>
                                            <StyledTableCell
                                                style={{ borderRight: "1px solid", borderColor: "#fff" }}
                                                align="center"
                                            >
                                                {row.weight}
                                            </StyledTableCell>
                                            <StyledTableCell
                                                style={{ borderRight: "1px solid", borderColor: "#fff" }}
                                                align="center"
                                            >
                                                {row.priceCount}
                                            </StyledTableCell>
                                            <StyledTableCell
                                                style={{ borderRight: "1px solid", borderColor: "#fff" }}
                                                align="center"
                                            >
                                                {row.count}
                                            </StyledTableCell>
                                            <StyledTableCell
                                                style={{ borderRight: "1px solid", borderColor: "#fff" }}
                                                align="center"
                                            >
                                                {row.price}
                                            </StyledTableCell>
                                        </StyledTableRow>
                                    ))}
                                    {/* <StyledTableRow>
                                        <StyledTableCell
                                            style={{ borderBottom: "1px solid", borderColor: "#fff" }}
                                        ></StyledTableCell>
                                        <StyledTableCell
                                            style={{ borderRight: "1px solid", borderColor: "#fff" }}
                                            align="left"
                                        >
                                            مجموع
                                      </StyledTableCell>
                                        <StyledTableCell
                                            style={{ borderRight: "1px solid", borderColor: "#fff" }}
                                            align="center"
                                        ></StyledTableCell>
                                        <StyledTableCell
                                            style={{ borderRight: "1px solid", borderColor: "#fff" }}
                                            align="center"
                                        ></StyledTableCell>
                                        <StyledTableCell
                                            style={{ borderRight: "1px solid", borderColor: "#fff" }}
                                            align="center"
                                        >
                                            {factor.totalPacks}
                                        </StyledTableCell>
                                        <StyledTableCell
                                            style={{ borderRight: "1px solid", borderColor: "#fff" }}
                                            align="center"
                                        >
                                            {factor.totalPrice}
                                        </StyledTableCell>
                                    </StyledTableRow> */}

                                    <StyledTableRow rowSpan={4}>
                                        <StyledTableCell colSpan={4}>
                                            توضیحات:
                    <br />
                                            <TextArea
                                                fullWidth
                                                multiline
                                                disabled
                                                value={factor.description}
                                                rows={5}
                                            />
                                        </StyledTableCell>

                                        <StyledTableCell
                                            style={{
                                                borderLeft: "1px solid #fff",
                                                borderRight: "1px solid #fff",
                                            }}
                                            rowSpan={4}
                                            align="center">
                                            تعداد بسته ها
                                            <br />
                                            <br />
                                            هزینه ارسال
                                            <br />
                                            <br />
                                            تخفیف
                                            <br />
                                            <br />
                                            <p
                                                style={{
                                                    padding: "5px",
                                                    border: "none",
                                                    color: "green",
                                                    fontWeight: "bold",
                                                }}>
                                                مجموع
                                        </p>
                                        </StyledTableCell>
                                        <StyledTableCell align="center" rowSpan={4}>
                                            <span>{factor.totalPacks}</span>
                                            <br />
                                            <br />
                                            {(factor.shippingCost) ? (
                                                <span>ارسال رایگان</span>
                                            ) : (
                                                <span>بر اساس هزینه پست</span>
                                            )}
                                            <br />
                                            <br />
                                            {factor.discount}
                                            <br />
                                            <br />
                                            <p
                                                style={{
                                                    color: "green",
                                                    fontWeight: "bold",
                                                    alignSelf: "center",
                                                }}
                                            >
                                                {globalFuncs.SepratePrice(factor.totalSum)}
                                            </p>
                                        </StyledTableCell>
                                    </StyledTableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </div>
                    {width > 1124 && (<Box mt={2} >
                        <Button className={classes.print} onClick={printDocument}> <PictureAsPdfIcon style={{ fill: 'red' }} /> دریافت pdf </Button>
                    </Box>)}
                    {(showBtn) && (
                        <>
                            <Box dir="ltr" mt={2} display="flex" textAlign="right">
                                <Link to="/profile/paid-invoices"><Button className={classes.btnWhite}>بازگشت به حساب کاربری</Button></Link>
                                 &nbsp;&nbsp;&nbsp;
                                <Link to="/products"><Button className={classes.btnBack}>بازگشت به فروشگاه</Button></Link>
                            </Box>
                        </>
                    )}

                </Box>
            </Box>
        );
    }
}
